import {
    Component,
    forwardRef,
    Host,
    OnInit,
    Optional,
    SkipSelf,
} from '@angular/core';

import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ClientAutocompleteControl } from 'appShared/classes';

import { BehaviorSubject } from 'rxjs';

import { AutocompleteComponent, AutocompleteOptionInterface } from '../../components';

import { ClientAutocompleteItemInterface } from './interfaces/client-autocomplete-item.interface';

@Component({
    selector: 'app-client-autocomplete',
    templateUrl: './client-autocomplete.component.html',
    styleUrls: ['./client-autocomplete.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ClientAutocompleteComponent),
        multi: true
    }]
})
export class ClientAutocompleteComponent extends AutocompleteComponent implements OnInit {
    private items: ClientAutocompleteItemInterface[];

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);
    }

    private createAutocompleteOptions(): AutocompleteOptionInterface[] {
        return this.items.filter((client: ClientAutocompleteItemInterface) => {
            return client.id && client.name;
        }).map((client: ClientAutocompleteItemInterface) => {
            return {
                label: client.name,
                value: client.id,
            };
        });
    }

    ngOnInit() {
        this.items = this.asFormsControl().clients;

        this.asFormsControl().options = this.createAutocompleteOptions();

        this.autocompleteOptions = new BehaviorSubject(this.asFormsControl().options);

        this.checkInvalid();
    }

    asFormsControl(): ClientAutocompleteControl {
        if (!this.control || !(this.control instanceof ClientAutocompleteControl)) {
            this.control = new ClientAutocompleteControl({
                name: '',
                value: '',
                placeholder: '',
                validators: [],
                componentType: 0,
                invalid: false,
                errors: [],
                options: [],
                clients: [],
            });
        }

        const control = (this.control as ClientAutocompleteControl);

        if (control.clients.length !== 0) {
            this.items = control.clients
                .sort((current: ClientAutocompleteItemInterface, next: ClientAutocompleteItemInterface) => {
                    if (current.name.toLowerCase() < next.name.toLowerCase()) {
                        return -1;
                    } else if (current.name.toLowerCase() > next.name.toLowerCase()) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

            control.options = this.createAutocompleteOptions();
        }

        return control;
    }
}
